import { Axios } from "./request";

const API_URL = "branchesapi/v1/Branches/";

export const BRANCHES_API = {
  GetMainBranch: () => {
    return Axios.get(`${API_URL}GetMainBranch`);
  },
  GetAvailableBranches: (filter = "") => {
    return Axios.get(`${API_URL}GetAvailableBranches/?${filter}`);
  },
};
